var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-tap-disabled":"true"}},[_c('mapbox',{class:{ minimized: _vm.mapMinimized },attrs:{"map-options":_vm.mapOptions,"access-token":_vm.mapAccessToken,"scale-control":{
      show: true,
      position: 'bottom-left'
    },"nav-control":{
      show: true
    }},on:{"map-init":_vm.onMapInitialized,"map-load":_vm.onMapLoaded,"map-click":_vm.onMapClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }